<template>
	<div class="wrap">
		<div class="login">
			<div class="content">
				<div class="login-content">
					<div class="logo"></div>
					<div class="login-form">
						<h3 class="welcome" style="text-align: center;">
							<img src="../../assets/title-logo.png" alt="logo" width="300" />
						</h3>
						<div class="login-wrap">
							<div class="form-content">
								<div class="form-item">
									<span class="iconfont icon-Icon-yonghuguanli usericon"></span>
									<input
										type="text"
										name="user_identification"
										:placeholder="$t('login.placeholderUserName')"
										autocomplete="off"
										v-model.trim="user.params.mobile"
									/>
								</div>
								<div class="form-item">
									<!-- <i class="fa fa-key input-icon"></i> -->
									<span class="iconfont icon-yuechi usericon"></span>
									<input
										type="password"
										name="pwd"
										:placeholder="$t('login.placeholderPassword')"
										autocomplete="off"
										v-model.trim="user.params.pwd"
									/>
								</div>
								<div class="auto">
									<label style="flex: 1;">
										<input type="checkbox" v-model="checked_autologin" />
										<span>{{ $t('login.autoLogin') }}</span>
									</label>
									<label style="flex: 1;">
										<input type="checkbox" v-model="checked_remember" />
										<span>{{ $t('login.rememberPassword') }}</span>
									</label>
								</div>
								<!-- :disabled="
										user.params.mobile === '' || user.params.pwd === ''
									" -->
								<a-button class="btn-login" type="primary" @click="login">
										{{ $t('login.logIn') }}
								</a-button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="background"
				style="left: 0px; top: 0px; overflow: hidden; margin: 0px; padding: 0px; height: 100%; width: 100%; z-index: -999999; position: fixed;"
			>
				<div class="bg-Color"></div>
			</div>
			<router-view></router-view>
		</div>
		<div
			class="backstretch"
			style="left: 0px; top: 0px; overflow: hidden; margin: 0px; padding: 0px; height: 100%; width: 100%; z-index: -999999; position: fixed;"
		>
			<img
				style="position: absolute; margin: 0px; padding: 0px; border: none;height: 100%; width: 100%; max-height: none; max-width: none; z-index: -999999; left: 0px; top: 0;"
				src="../../images/1.jpg"
			/>
		</div>
	</div>
</template>

<script>
import { reqlogin } from "../../api/login";
export default {
	name: "login",
	data() {
		return {
			user: {
				meta: {
					code: "agent-tms",
					client: "PC",
					tag: "agent-tms",
					time: Date.now(),
				},
				params: {
					mobile: "",
					pwd: "",
				},
			},
			checked_remember: false,
			checked_autologin: false,
		};
	},
	watch: {
		checked_remember() {
			localStorage.setItem("checked_remember", this.checked_remember);
			if (!this.checked_remember) {
				localStorage.setItem("remenber_user", "{}");
			}
		},
		checked_autologin() {
			localStorage.setItem("checked_autologin", this.checked_autologin);
			if (!this.checked_autologin) {
				localStorage.setItem("remenber_user", "{}");
			}
		},
	},
	created() {
		// enter登录
		var _self = this;
		document.onkeydown = function() {
			var key = window.event.keyCode;
			if (key == 13) {
				_self.login();
			}
		};
		// 记住密码
		let remenber_user = localStorage.getItem("remenber_user");
		if (remenber_user == null) {
			remenber_user = {};
		} else {
			remenber_user = JSON.parse(remenber_user);
		}
		let checked_remember = localStorage.getItem("checked_remember");
		if (checked_remember != null) {
			this.checked_remember = checked_remember == "true" ? true : false;
		}
		if (this.checked_remember) {
			this.user.params.mobile = remenber_user.mobile;
			this.user.params.pwd = remenber_user.pwd;
		}

		// 自动登录
		let autologin_user = localStorage.getItem("autologin_user");
		if (autologin_user == null) {
			autologin_user = {};
		} else {
			autologin_user = JSON.parse(autologin_user);
		}
		let checked_autologin = localStorage.getItem("checked_autologin");
		if (checked_autologin != null) {
			this.checked_autologin = checked_autologin == "true" ? true : false;
		}
		if (this.checked_autologin && autologin_user.mobile && autologin_user.pwd) {
			this.user.params.mobile = autologin_user.mobile;
			this.user.params.pwd = autologin_user.pwd;
			this.login();
		}

		// // 在页面加载时从cookie获取登录信息
		// let mobile = localStorage.getItem("mobile");
		// let pwd = localStorage.getItem("pwd");
		// // let checked_autologin = localStorage.getItem("checked_autologin");
		// // let pwd = Base64.decode(this.getCookie("pwd"))
		// // 如果存在赋值给表单，并且将记住密码勾选
		// if (mobile) {
		// 	this.user.params.mobile = mobile;
		// 	this.user.params.pwd = pwd;
		// 	this.checked_remember = true;
		// } else {
		// 	this.user.params.mobile = "";
		// 	this.user.params.pwd = "";
		// 	this.checked_remember = false;
		// 	localStorage.setItem("Authorization","");
		// }
	},
	methods: {
		login() {
			console.log("点击了登录");
			if (
				this.user.params.mobile == "" ||
				this.user.params.mobile == undefined ||
				this.user.params.pwd == "" ||
				this.user.params.pwd == undefined
			) {
				console.log(this.user);
				this.$message.error(this.$t('pleaseEnterYourAccountNumberAndPassword'));
				return;
			}
			if (this.user.params.mobile !== "" && this.user.params.pwd !== "") {
				console.log("req ===> ", this.user);
				reqlogin(this.user).then((res) => {
					// console.log(this.user, "=======", res);
					let temp = JSON.parse(res.data);
					console.log("temp === ", temp);
					if (!temp.success || temp.code != "0") {
						this.$message.error(temp.msg);
						return;
					}
					if (temp.success == true && temp.data !== "") {
						let storage = window.localStorage;
						let Authorization = temp.data;
						let userInfo = {
							Authorization: Authorization,
						};
						storage.setItem("userInfo", JSON.stringify(userInfo));
						this.setUserInfo();

						this.$router.push("/business-dispatch");
						// this.setUserInfo();
					}
				});
			}
		},
		// 存储表单信息
		setUserInfo() {
			// 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
			// 如果没有勾选，储存的信息为空
			if (this.checked_remember) {
				let passWord = this.user.params.pwd; // 明文存储
				// let passWord = Base64.encode(this.user.params.pwd)
				localStorage.setItem(
					"remenber_user",
					JSON.stringify({
						mobile: this.user.params.mobile,
						pwd: passWord,
					})
				);
			} else {
				localStorage.setItem("remenber_user", "{}");
			}
			if (this.checked_autologin) {
				let passWord = this.user.params.pwd; // 明文存储
				// let passWord = Base64.encode(this.user.params.pwd)
				localStorage.setItem(
					"autologin_user",
					JSON.stringify({
						mobile: this.user.params.mobile,
						pwd: passWord,
					})
				);
			} else {
				localStorage.setItem("autologin_user", "{}");
			}
		},
	},
};
</script>
<style lang="less" scoped>
@import "./login.less";
</style>
